/**
 * Classes com requisições para salvar / atualizar as preferencias do usuário
 *
 */


Greenmile.UserPreferences = Greenmile.UserPreferences || {};
Greenmile.UserPreferences.Requests = function () {

    var gmStorage = new Greenmile.Storage.StoreMapPosition();

    this.getInitUserPreferences = function (callback) {
        var _data = Monet.Session.ApplicationLoad.genericUserScreenPreferences;


        _data = _data.filter(function (item) {
            return (item.key !== 'setItem' &&
            item.key !== 'getItem' &&
            item.key !== 'clear');
        });

        if (callback) {
            callback(_data);
        }
    };

    this.getRequestUrl = function () {
        const featuresStates = GreenmileReduxStore.getState().features;

        const liveMetadataIsEnabled = featuresStates.has('LIVE_METADATA') && 
            featuresStates.get('LIVE_METADATA')?.enabled;

        if (liveMetadataIsEnabled) {
            const tenant = Greenmile.Utils.getTenant();

            return `/live-metadata/UserScreenPreference/alias/${tenant}/all`;
        }

        return 'GenericUserScreenPreference/batch';
    };

    this.setPreferencesByBatch = function (listPreferences, callback) {
       
        try {
            const request = new Monet.Ajax();
            const url = this.getRequestUrl();

            request.url = url;
            request.method = 'POST';
            request.data = listPreferences;
            request.error = function (xhr) {
                Monet.Configurations.errorNotification(null, xhr);
            };

            request.success = function (data) {
                gmStorage.setIsUpdated();

                if (callback) {
                    callback(data);
                }
            };

            request.send();
        } catch (e) {
            new Monet.Exception
                .ReturnError(this, 'Error on set preferences by batch', e)
                .console();
        }
    };

};
